/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'x': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" id="svgicon_x_a" d="M13 11h9v2h-9v9h-2v-9H2v-2h9V2h2z"/></defs><use _fill="#000" transform="rotate(45 12 12)" xlink:href="#svgicon_x_a" fill-rule="evenodd"/>'
  }
})
